import { getSurvicateInstance, initSurvicate } from "@survicate/survicate-web-surveys-wrapper";

const SURVICATE_WORKSPACE_KEY = "7697bcf2843ee30112ae75a9b7cd18e9";

export enum SurvicateEvents {
    VOKABELTEST_SAVED = "vokabeltest_saved",
}

// Resolved once the Survicate SDK is loaded; null means startSurvicate was never
// called (no analytics consent yet) or the last initialization attempt failed.
let survicateReady: Promise<void> | null = null;

export function startSurvicate(): void {
    if (survicateReady) {
        return;
    }

    survicateReady = initSurvicate({ workspaceKey: SURVICATE_WORKSPACE_KEY }).catch((error) => {
        // Reset so a later call (e.g. next route change) can retry after a transient failure.
        survicateReady = null;
        console.error("Error initializing Survicate:", error);
    });
}

export async function invokeSurvicateEvent(eventName: string, eventProperties?: Record<string, string>): Promise<void> {
    if (!survicateReady) {
        // Survicate never started (no consent) — surveys must not appear, so the event is dropped.
        return;
    }

    await survicateReady;
    try {
        getSurvicateInstance()?.invokeEvent(eventName, eventProperties);
    } catch (error) {
        // Fire-and-forget call sites can't catch this, so swallow it here to avoid an
        // unhandled rejection — a missed survey trigger must never break the save flow.
        console.error("Error invoking Survicate event:", error);
    }
}
